const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/factory/home";
PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";

PATHS.MOVEMENT_PROCESS = "/factory/movement/new";
PATHS.NEW_PROCESS = "/factory/process/new";
PATHS.LIST_ORDERS = "/factory/order/list";
PATHS.ORDER_DETAIL = "/factory/order/detail/:uuid";
PATHS.NEW_ORDER = "/factory/order/new";
PATHS.UPDATE_ORDER = "/factory/order/update/:uuid";
PATHS.OUT_LIST = "/factory/output/list";
PATHS.STOP_LIST = "/factory/stopHistory/list";
PATHS.MOVE_LIST = "/factory/moveFlow/list";
PATHS.MOVE_ERROR_LIST = "/factory/moveFlow/errors";
PATHS.ITEMS_LIST = "/factory/items/list";
PATHS.AUX_ITEMS_LIST = "/factory/auxItems/list";
PATHS.NEW_AUX_ITEMS = "/factory/auxItems/register";
PATHS.JUNCTIONS = "/factory/juctions";
PATHS.EXT_CONTROL_LIST = "/factory/ext-control/list";
PATHS.NEW_EXT_CONTROL = "/factory/ext-control/new";
PATHS.UPDATE_EXT_CONTROL = "/factory/ext-control/update/:uuid";
PATHS.STOCK_LIST = "/factory/stock/list";

PATHS.EXPEDITION = "/factory/expedition";
PATHS.CYCLONE = "/factory/cyclone";
PATHS.NIMBUS = "/factory/nimbus";
PATHS.SECADO = "/factory/secado";

PATHS.TURN_LIST = "/factory/turn/list";
PATHS.CLOSE_TURN = "/factory/turn/close";

PATHS.UPDATE_MOVEFLOW = "/factory/moveFlow/update/:uuid";

PATHS.PRODUCTION_ORDER_SAP_LIST = "/factory/productionOrderSap/list";
PATHS.PRODUCTION_ORDER_SAP_DETAIL = "/factory/productionOrderSap/detail/:uuid";

PATHS.MOVEMENT_LIST = "/factory/movement/list";

PATHS.INVENTARY_LIST = "/factory/inventary/list";
PATHS.INVENTARY_DETAIL = "/factory/inventary/detail/:uuid";

PATHS.EXPEDITION_LIST = "/factory/expedition/list";
PATHS.EXPEDITION_DETAIL = "/factory/expedition/detail/:uuid";

export default PATHS;
